export default "__VITE_ASSET__Dq1UbdNX__"